// extracted by mini-css-extract-plugin
export default {"container":"LinkCard_container__Vuy4R","studentK2Container":"LinkCard_studentK2Container__zo1-0","highContrast":"LinkCard_highContrast__0YpbE"};